import { render, staticRenderFns } from "./PatientEdit.vue?vue&type=template&id=4c8a4f76&scoped=true&"
import script from "./PatientEdit.vue?vue&type=script&lang=js&"
export * from "./PatientEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a4f76",
  null
  
)

export default component.exports